import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@shared/component/base/base.component';
import { ServiceProductCollection } from 'taxtank-core';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';

@Component({
  selector: 'app-subscription-banner-trial',
  templateUrl: './subscription-banner-trial.component.html',
  styleUrls: ['./subscription-banner-trial.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerTrialComponent extends BaseComponent {
  public dialog = inject(MatDialog);
  public products = inject<ServiceProductCollection>(MAT_DIALOG_DATA);

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large'
    });
  }
}
